/**
 * Helpers pour détecter le contexte iframe widget (embed / checkout / thank-you).
 */

export function isPageEmbeddedInIframe(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

export function isWidgetSourceQuery(search?: string): boolean {
  if (typeof window === 'undefined') return false;
  const raw = search ?? window.location.search;
  return new URLSearchParams(raw).get('source') === 'widget';
}

/** Checkout chargé dans l'iframe SDK (`/checkout?source=widget`). */
export function isWidgetCheckoutFrame(search?: string): boolean {
  if (typeof window === 'undefined') return false;
  return (
    window.location.pathname === '/checkout' &&
    isWidgetSourceQuery(search) &&
    isPageEmbeddedInIframe()
  );
}

/** Page de confirmation après paiement widget in-frame. */
export function isWidgetThankYouFrame(search?: string): boolean {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(search ?? window.location.search);
  const widgetReturn = params.get('cart') === 'true' || params.get('source') === 'widget';
  return window.location.pathname === '/thank-you' && widgetReturn && isPageEmbeddedInIframe();
}
